// extracted by mini-css-extract-plugin
export default {"rating":"ZC-z","numberOfStars":"_C-z","count":"aD-z","barGraphSpacing":"bD-z","barGraph":"cD-z"};